import * as tagColor from './CountTag.module.scss';

import { CountTag } from './CountTag';
import { RobotOutlined } from '@ant-design/icons';

import React, { memo } from 'react';

export interface ReferenceCountTagProps {
	count: number;
}

export const ReferenceCountTag: React.FC<ReferenceCountTagProps> = memo(({ count }) =>
	<CountTag
		color={ tagColor.referenceCount }
		count={ count }
		icon={ <RobotOutlined /> }
		tooltip={ `This field has ${count} references.` }
		visible={ count > 0 } />);
